import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import img from "./all_bg.jpg";

const BACKEND_URL = "https://api.bbsfacultyprofile.com";
const TABLE_NAME = "research_grant_proposal_reviewed";

const ResearchGrantProposalReviewed = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [formData, setFormData] = useState({
    year: null,
    title: "",
    institution: "",
    amount: "",
    country: "",
  });
  const [recordId, setRecordId] = useState(null);

  const fetchRecords = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/${TABLE_NAME}`, {
        method: "GET",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Failed to fetch records");
      const data = await res.json();
      console.log("Data received from database:", data);

const sortedData = (Array.isArray(data) ? data : []).sort(
  (a, b) => {
    return new Date(b.year) - new Date(a.year);
  }
);

setRecords(sortedData);
    } catch (err) {
      console.error(err);
      toast.error(`Fetch error: ${err.message}`);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
  ...formData,

  year: formData.year
  ? `${formData.year.getFullYear()}-${String(
      formData.year.getMonth() + 1
    ).padStart(2, "0")}-01`
  : null,

  amount: parseFloat(formData.amount) || 0,
};

      const url = recordId
        ? `${BACKEND_URL}/api/${TABLE_NAME}/${recordId}`
        : `${BACKEND_URL}/api/${TABLE_NAME}`;
      const method = recordId ? "PUT" : "POST";
      console.log("Payload sent to backend:", payload);
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });
        console.log("Response status:", res.status);
      if (!res.ok) throw new Error("Failed to save record");

      toast.success("Record saved successfully!");
      setFormData({
        year: null,
        title: "",
        institution: "",
        amount: "",
        country: "",
      });
      setRecordId(null);
      fetchRecords();
    } catch (err) {
      console.error(err);
      toast.error(`Submit error: ${err.message}`);
    }
  };

  const handleEdit = (rec) => {
  setFormData({
    year: rec.year
  ? (() => {
      const parts = rec.year.split("-");
      return new Date(
        Number(parts[0]),
        Number(parts[1]) - 1,
        1
      );
    })()
  : null,

    title: rec.title || "",
    institution: rec.institution || "",
    amount: rec.amount?.toString() || "",
    country: rec.country || "",
  });

  setRecordId(rec.id);
  toast.info("Editing record...");
};

  const handleDelete = (rec) => {
    const toastId = toast.info(
      <div>
        Delete this record?{" "}
        <button
          onClick={async () => {
            try {
              const res = await fetch(
                `${BACKEND_URL}/api/${TABLE_NAME}/${rec.id}`,
                { method: "DELETE", credentials: "include" }
              );
              if (!res.ok) throw new Error("Failed to delete record");
              fetchRecords();
              toast.update(toastId, {
                render: "Record deleted successfully!",
                type: "success",
                autoClose: 3000,
                closeButton: true,
              });
            } catch (err) {
              toast.update(toastId, {
                render: `Delete error: ${err.message}`,
                type: "error",
                autoClose: 3000,
                closeButton: true,
              });
            }
          }}
          style={{
            marginLeft: "10px",
            padding: "3px 8px",
            background: "#ef4444",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Confirm
        </button>
      </div>,
      { autoClose: false, closeOnClick: false }
    );
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px 20px",
        fontFamily: "Arial, sans-serif",
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <ToastContainer position="top-center" autoClose={3000} />
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          background: "#fff",
          padding: "30px 40px",
          borderRadius: "10px",
          boxShadow: "0px 0px 12px rgba(0,0,0,0.1)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: "#1e3a8a",
            marginBottom: "25px",
          }}
        >
          Research Grant Proposals Reviewed
        </h2>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column" }}
        >
          {/* Year Picker */}
          <div>
            <label style={{ fontWeight: "bold", marginTop: "10px" }}>
              Grant Proposal Reviewing Year (mm/yyyy)
              <span
                style={{
                  fontWeight: 300,
                  fontSize: "0.85em",
                  marginLeft: "6px",
                  color: "#666",
                }}
              >
                (start with latest review)
              </span>
            </label>
            <DatePicker
  selected={formData.year}
  onChange={(date) => {
    if (!date) {
      setFormData({
        ...formData,
        year: null,
      });
      return;
    }

    const selectedDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      1
    );

    setFormData({
      ...formData,
      year: selectedDate,
    });
  }}
  dateFormat="MM/yyyy"
  showMonthYearPicker
  placeholderText="Select month/year"
/>
<p>
Selected:
{formData.year &&
  `${formData.year.getMonth()+1}/${formData.year.getFullYear()}`
}
</p>
          </div>

          {[
            { label: "Grant Title", name: "title" },
            {
              label: "Grant Amount (BDT)",
              name: "amount",
              type: "number",
              step: "0.01",
              note: "use equivalent value in BDT if received in other currency",
            },

            { label: "Institution", name: "institution" },
            { label: "Country", name: "country" },
          ].map((field) => (
            <div key={field.name}>
              <label style={{ fontWeight: "bold", marginTop: "10px" }}>
                {field.label}
              </label>
              <label style={{ fontWeight: "bold", marginTop: "10px" }}>
                {field.note && (
                  <span
                    style={{
                      fontWeight: 300,
                      fontSize: "0.85em",
                      marginLeft: "6px",
                      color: "#666",
                    }}
                  >
                    ({field.note})
                  </span>
                )}
              </label>

              <input
                type={field.type || "text"}
                step={field.step || undefined}
                name={field.name}
                value={formData[field.name]}
                onChange={(e) => {
                  let value = e.target.value;
                  if (field.name === "amount") {
                    // filter non-numeric input
                    value = value.replace(/[^0-9.]/g, "");
                  }
                  setFormData({ ...formData, [field.name]: value });
                }}
                style={{
                  padding: "10px",
                  marginTop: "5px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  width: "100%",
                }}
                required
              />
            </div>
          ))}

          <button
            type="submit"
            style={{
              background: "#3b82f6",
              color: "white",
              padding: "12px",
              border: "none",
              borderRadius: "6px",
              marginTop: "20px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {recordId ? "Update Record" : "Add Record"}
          </button>
        </form>

        {/* Table */}
        {records.length > 0 && (
          <div style={{ marginTop: "30px", overflowX: "auto" }}>
            <h3 style={{ color: "#1e3a8a" }}>Your Records</h3>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "10px",
              }}
            >
              <thead>
                <tr>
                  {[
                    "Year (mm/yy)",
                    "Grant Title",
                    "Grant Amount",
                    "Institution",
                    "Country",
                    "Actions",
                  ].map((h) => (
                    <th
                      key={h}
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        background: "#f1f5f9",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {records.map((rec) => (
                  <tr key={rec.id}>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.year
                        ? `${rec.year.slice(5, 7)}/${rec.year.slice(0, 4)}`
                        : ""}
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.title}
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.amount}
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.institution}
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {rec.country}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <button
                        onClick={() => handleEdit(rec)}
                        style={{
                          background: "#2563eb",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          marginRight: "5px",
                          cursor: "pointer",
                        }}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(rec)}
                        style={{
                          background: "#ef4444",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: "25px" }}>
          <button
            onClick={() => navigate("/dashboard")}
            style={{
              background: "#1e3a8a",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResearchGrantProposalReviewed;
